'use client';

import { type ComponentProps, useEffect, useState } from 'react';

import { cn } from '@/lib/utils';

type ImageDimensions = {
    width: number;
    height: number;
};

export default function ProductPageZoomLink({
    className,
    children,
    href,
    ...props
}: ComponentProps<'a'>) {
    const [imageDimensions, setImageDimensions] = useState<ImageDimensions>({
        width: 2000,
        height: 2000,
    });

    useEffect(() => {
        if (!href) {
            return;
        }

        /**
         * Since we don't get the image dimesions from Norce and Loop54, we need to grab the image width and height from the image element itself.
         * Otherwise the zoom won't work properly with PhotoSwipe.
         */
        const image = new Image();
        image.src = href;

        image.onload = () => {
            setImageDimensions({
                width: image.width,
                height: image.height,
            });
        };
    }, [href]);

    return (
        <a
            className={cn('hover:cursor-zoom-in', className)}
            data-pswp-src={href}
            data-pswp-width={imageDimensions.width}
            data-pswp-height={imageDimensions.height}
            target="_blank"
            {...props}>
            {children}
        </a>
    );
}
